import React, { useState } from "react"

import "./App.css"
import { Frame } from "./frame/Frame"
import { Restart } from "./frame/Restart"
import { Quiz } from "./quiz/Quiz"
import { VideoPlayer } from "./video_player/VideoPlayer"

enum Stage {
  IntroVideo,
  Quiz1,
  MiddleVideo,
  Quiz2,
  EndVideo,
  RestartScreen,
}

const App = () => {
  const [stage, setStage] = useState(Stage.IntroVideo)
  const [mediaInterest, setMediaInterest] = useState(false) //set true when user interacts with app

  const handleSkipBackwards = () => {
    setMediaInterest(true)
    switch (stage) {
      case Stage.Quiz1:
        setStage(Stage.IntroVideo)
        break
      case Stage.MiddleVideo:
        setStage(Stage.Quiz1)
        break
      case Stage.Quiz2:
        setStage(Stage.MiddleVideo)
        break
      case Stage.EndVideo:
        setStage(Stage.Quiz2)
        break
      case Stage.RestartScreen:
        setStage(Stage.EndVideo)
    }
  }

  const handleSkipForwards = () => {
    setMediaInterest(true)
    switch (stage) {
      case Stage.IntroVideo:
        setStage(Stage.Quiz1)
        break
      case Stage.Quiz1:
        setStage(Stage.MiddleVideo)
        break
      case Stage.MiddleVideo:
        setStage(Stage.Quiz2)
        break
      case Stage.Quiz2:
        setStage(Stage.EndVideo)
        break
      case Stage.EndVideo:
        setStage(Stage.RestartScreen)
    }
  }

  // Extract out components in order to preload the resources
  const IntroVideo = () => (
    <VideoPlayer
      url={process.env.PUBLIC_URL + "/videos/video_1.mp4"}
      onVideoFinish={() => setStage(Stage.Quiz1)}
      mediaInterest={mediaInterest}
      onPlayClicked={() => setMediaInterest(true)}
    />
  )

  const Quiz1 = () => (
    <Quiz quizIndex={0} onQuizComplete={() => setStage(Stage.MiddleVideo)} />
  )

  const MiddleVideo = () => (
    <VideoPlayer
      url={process.env.PUBLIC_URL + "/videos/video_2.mp4"}
      onVideoFinish={() => setStage(Stage.Quiz2)}
      mediaInterest={mediaInterest}
    />
  )

  const Quiz2 = () => (
    <Quiz quizIndex={1} onQuizComplete={() => setStage(Stage.EndVideo)} />
  )

  const EndVideo = () => (
    <VideoPlayer
      url={process.env.PUBLIC_URL + "/videos/video_3.mp4"}
      mediaInterest={mediaInterest}
    />
  )

  const Children = () => {
    switch (stage) {
      case Stage.IntroVideo:
        return <IntroVideo />
      case Stage.Quiz1:
        return <Quiz1 />
      case Stage.MiddleVideo:
        return <MiddleVideo />
      case Stage.Quiz2:
        return <Quiz2 />
      case Stage.EndVideo:
        return <EndVideo />
      case Stage.RestartScreen:
        return <Restart onRestart={() => setStage(Stage.IntroVideo)} />
      default:
        return null
    }
  }
  return (
    <Frame
      onSkipBackwards={handleSkipBackwards}
      onSkipForwards={handleSkipForwards}
    >
      <Children />
    </Frame>
  )
}

export default App
